import { createSlice } from "@reduxjs/toolkit";
import VwKurumbonustanimDTO from "src/models/KurumBonusTanim/VwKurumbonustanimDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IKurumBonusTanimlari {
    aktifGetir: string;
    iptalGosterme: string;
    activeRow: VwKurumbonustanimDTO;
    open: boolean;
};

export const kurumBonusTanimlariSlice = createSlice<IKurumBonusTanimlari, MapReducerPayloads<IKurumBonusTanimlari, {
    setAktifGetir: string;
    setIptalGosterme: string;
    setActiveRow: VwKurumbonustanimDTO;
    setOpen: boolean;
}>>({
    name: "kurumBonusTanimlari",
    initialState: {
        aktifGetir: "E",
        iptalGosterme: "E",
        activeRow: new VwKurumbonustanimDTO(),
        open: false,
    },
    reducers: {
        setAktifGetir: (state, action) => {
            state.aktifGetir = action.payload;
        },
        setIptalGosterme: (state, action) => {
            state.iptalGosterme = action.payload;
        },
        setActiveRow: (state, action) => {
            state.activeRow = action.payload;
        },
        setOpen: (state, action) => {
            state.open = action.payload;
        },
    },
});